import { MapPinned } from "lucide-react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

type OpenMapCtaProps = {
  onOpenMap: () => void;
  className?: string;
};

/**
 * Decorative map-area placeholder. Does not load Google Maps — only the CTA
 * mounts the real MapView (Dynamic Maps billing).
 */
export function OpenMapCta({ onOpenMap, className }: OpenMapCtaProps) {
  return (
    <div
      className={cn(
        "relative h-full min-h-[280px] w-full overflow-hidden rounded-md border border-neutral-lighter bg-neutral-lightest",
        className,
      )}
    >
      {/* Soft map-grid backdrop (no Google tiles) */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-70"
        style={{
          backgroundImage: `
            linear-gradient(to right, color-mix(in oklch, var(--neutral-light) 55%, transparent) 1px, transparent 1px),
            linear-gradient(to bottom, color-mix(in oklch, var(--neutral-light) 55%, transparent) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_35%,color-mix(in_oklch,var(--neutral-lightest)_90%,transparent)_100%)]"
      />
      {/* Decorative pins */}
      <MapPinned
        aria-hidden
        className="absolute left-[18%] top-[28%] size-8 text-neutral-dark/35"
      />
      <MapPinned
        aria-hidden
        className="absolute right-[22%] top-[36%] size-10 text-lemon-dark/50"
      />
      <MapPinned
        aria-hidden
        className="absolute bottom-[30%] left-[42%] size-7 text-neutral-dark/30"
      />

      <div className="relative z-10 flex h-full items-center justify-center p-4 md:p-5">
        <div className="w-full rounded-md bg-white px-4 py-6 text-center shadow-lg md:px-5 md:py-7">
          <h2 className="text-lg font-semibold text-neutral-darkest md:text-xl">
            Locations auf der Karte finden
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-neutral-dark">
            Entdecke Eventlocations in deiner Region auf einen Blick und grenze
            die Suche über den Kartenausschnitt ein.
          </p>
          <Button
            type="button"
            variant="default"
            size="lg"
            className="mt-5 w-full"
            onClick={onOpenMap}
          >
            Karte öffnen
          </Button>
        </div>
      </div>
    </div>
  );
}
